import React, { useCallback, useMemo } from 'react'

import type { FunctionComponent } from 'react'
import type { BaseEntity } from '@ztechapps/common.contract'

import { useHistory } from '@ztechapps/common.hook'
import { RouteOffCanvas } from '@ztechapps/webui.util'

import type { OnSelectFunction } from './types'

type ListOffCanvasLayoutProps = {
  listRoutePath: string
  listComponent: FunctionComponent<{ onRowDoubleClick: OnSelectFunction }>
  offcanvasWidth?: string
  widthStorageKey?: string
  onRowDoubleClick?: OnSelectFunction
}
export const DataTableOffCanvas = ({
  listComponent: List,
  listRoutePath,
  offcanvasWidth = '90%',
  widthStorageKey,
  onRowDoubleClick,
}: ListOffCanvasLayoutProps) => {
  const history = useHistory()

  const internalOnRowDoubleClick: OnSelectFunction<BaseEntity> = useCallback(
    (entity) => {
      if (onRowDoubleClick) {
        return onRowDoubleClick(entity)
      }

      history.push(`${listRoutePath}/${entity._id}`)
    },
    [onRowDoubleClick, history, listRoutePath]
  )

  const listElement = useMemo(
    () => <List onRowDoubleClick={internalOnRowDoubleClick} />,
    [List, internalOnRowDoubleClick]
  )

  return (
    <RouteOffCanvas listRoutePath={listRoutePath} defaultWidth={offcanvasWidth} widthStorageKey={widthStorageKey}>
      {listElement}
    </RouteOffCanvas>
  )
}
